"use client";

import { ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";
import { getOpenSeaItemUrl } from "@/lib/opensea";

interface OpenSeaLinkProps {
  tokenId: number;
  className?: string;
}

export function OpenSeaLink({ tokenId, className }: OpenSeaLinkProps) {
  return (
    <a
      href={getOpenSeaItemUrl(tokenId)}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "inline-flex items-center gap-1.5 text-xs font-medium text-primary transition-opacity hover:opacity-80",
        className
      )}
      onClick={(e) => e.stopPropagation()}
      aria-label={`View Cat #${tokenId} on OpenSea`}
    >
      <ExternalLink size={14} />
      OpenSea
    </a>
  );
}
